module.exports = __webpack_public_path__ + "img/reservation.2f2fdb7b.svg";